<app-main-layout titre="Hermès" srcLogo="assets/svg/logo.svg" srcLogoDepartement="assets/svg/departement77.svg" bgColorPage="#e5e7f0">
</app-main-layout>
